import React from 'react';
import TaxTable from './components/TaxTable';

// <TaxLine amount="{item.amount}" tax="{item.tax}" real="{item.real}"></TaxLine>

function App() {

  return (
    <div>
      <TaxTable></TaxTable>
    </div>
  );
}

export default App;
